export default {
      id: "icon-qr-code-usage",
      viewBox: "0 0 158 158",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-qr-code",
      toString: function () {
        return this.url;
      }
    }